import { render } from "./MsisdnGroupsList.vue?vue&type=template&id=5109c7c8&scoped=true"
import script from "./MsisdnGroupsList.vue?vue&type=script&lang=js"
export * from "./MsisdnGroupsList.vue?vue&type=script&lang=js"

import "./MsisdnGroupsList.vue?vue&type=style&index=0&id=5109c7c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5109c7c8"]])

export default __exports__